import api from "./axios";

export const getAdjustments =
() =>
api.get(
  "/stock-adjustments"
);

export const createAdjustment =
(data)=>
api.post(
  "/stock-adjustments",
  data
);